import
  React, {
  useContext,
  useState
}	from 'react';

import {
  useHistory,
  useParams
} from 'react-router';

import {
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  CustomColors,
  ErrorKeys
} from '../../../../constants';

import {
  BackButton
} from 'components';

import {
  VoucherCard
} from '../components';

import {
  useCatalogue
} from '../hooks';

import {
  getStorageWithExpiry,
  isAdvanceEligible,
  printCurrency
} from 'helpers';

import {
  AppContext
} from 'context';

const VoucherAdvanceVendorUI = (props) => {

  const { vendorId } = useParams();
  const history = useHistory();
  const { config } = useContext(AppContext);

  const catalogue = useCatalogue(vendorId, true);

  const [ maxSavings, setMaxSavings ] = useState(0);

  VoucherAdvanceVendorUI.tagViewData = {
    event_name:'page_view,journey_start',
    journey_step:`cbu: connectu: voucher advance: ${catalogue?.content?.category}: which voucher would you like`,
    journey_name: 'cbu: connectu: voucher advance',
    journey_type : 'transaction',
    page_section: 'voucher advance',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_type: 'consumer',
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
    voucher_advance_eligibility: catalogue?.content?.eligibility?.eligibility ? 'advance' : 'pay now'
  };

  const buildBadge = (normal, advance, isAdvance) => {

    const sum = Math.floor((normal - advance) / advance * 100);

    if (maxSavings < sum) {
      setMaxSavings(sum);
    }

    if (!!isAdvance) {
      return 'ADVANCE AVAILABLE';
    }

    return sum > 0 ? `Get ${sum}% more value` : null;
  };

  const Hero = () => {

    return (

      <Image
        width={'100%'}
        height={'auto'}
        minHeight={'100px'}
        color={CustomColors.Black}
        src={catalogue.content?.attachment?.banner} />
    );
  };

  const Cards = () => {

    const list = [];

    if (!catalogue.content?.products?.length) {

      return (

        <Text
          key={'no-vouchers-available'}
          fontSize={'18px'}
          fontWeight={'bold'}
          padding={'16px 0'}
          color={CustomColors.Grey9}
          dangerouslySetInnerHTML={{ __html: config?.voucherAdvanceConfig?.vouchersUnavailableError }}/>

      );
    }

    list.push(

      <Text
        key={'voucher-list-header-text'}
        fontWeight='bold'
        fontSize={'18px'}
        fontColor={CustomColors.Grey9}>

        Which Voucher would you like?
      </Text>
    );

    for (let i = 0; i < catalogue.content?.products?.length; i ++) {

      const product = catalogue.content?.products[i];

      list.push(

        <VoucherCard
          isLoading={false}
          isError={false}
          key={`voucher-${i}`}
          logo={catalogue.content?.attachment?.url}
          voucherValue={printCurrency(product?.retailPrice)}
          title={`Get ${printCurrency(product?.normal?.currency)}`}
          subtitle={<>When you <b>pay now</b></>}
          badge={
            buildBadge(
              product?.normal?.currency,
              product?.retailPrice,
              (product?.purchaseType?.advance || product?.purchaseType?.Advance)
              && isAdvanceEligible(catalogue.content?.eligibility, product?.retailPrice)
            )
          }
          onClick={() => {

            history.push({
              pathname: '/voucher-advance/order',
              state: {
                vendorId: vendorId,
                voucherId: product?.id
              }
            });
          }}
          finePrint={`*${product?.validity}`}
          />
      );
    }

    return list;
  };

  return (

    <HandleRender
      isLoading={catalogue.isLoading}
      isError={catalogue.isError}
      error={{
        type: ErrorKeys.Empty
      }}>

        {
          <Hero/>
        }

        <BackButton
          margin={'16px 0 24px 16px'}
          onClick={() => history.goBack()} />

          <VContainer
            padding={'0 16px 35px'}>

            <Cards/>
          </VContainer>
    </HandleRender>
  );
};

VoucherAdvanceVendorUI.pageName = 'cbu: connectu: voucher advance: which voucher would you like';

export const VoucherAdvanceVendor = withScreenViewTagging(VoucherAdvanceVendorUI);